import { LabelWithInfo } from "../label-with-info";

type Props = {
  label: React.ReactNode;
};

export function HsaidLabel({ label }: Props) {
  return (
    <LabelWithInfo
      label={label}
      info={
        <span>
          Efter du skickat en beställning till KVK och vi godkänner SITHS-kortet i
          profilen så går ett automatiserat mail ut till konsulten med information kring
          att vi beställt ett kort och hur hen ska gå till väga för att hämta ut och
          aktivera kortet.
        </span>
      }
    />
  );
}
